import { Input } from "../Input";
import { useTemplates } from "actions/RFQ/templateAction";

const SelectTemplate = ({
	selectedRFQOptions,
	setSelectedRFQOptions,
	setSelectedTemplate,
}) => {
	const { data: template = [], isLoading } = useTemplates();

	const createTemplateOptions = [
		{ value: "createRFQ", label: "Create my own RFx", icon: "text-input" },
		{ value: "templateRFQ", label: "Import from template", icon: "template" },
	];

	const templateOptions = template.map((item) => ({
		value: item.id,
		label: item.name,
	}));

	const handleChangeRFQOption = (e) => {
		setSelectedRFQOptions(e);
		if (e.value === "createRFQ") {
			setSelectedTemplate(null);
		}
	};
	const handleChangeRFQTemplate = (e) => {
		setSelectedTemplate(e);
	};

	return (
		<div>
			<div className="mb-8 gap-5 rounded-md bg-utility-blue-light-100 p-8">
				<div className="mb-8">
					<p className="font-normal">Select an option below<span className="text-red-600">*</span></p>
				</div>
				<div className="space-y-5">
					<Input
						onChange={handleChangeRFQOption}
						type="select"
						options={createTemplateOptions}
						isContainImg={true}
						checkIcon={true}
						placeholder="Select an option"
						value={selectedRFQOptions}
						testId="select-rfq-option"
					/>

					{selectedRFQOptions?.value === "templateRFQ" && (
						<Input
							onChange={handleChangeRFQTemplate}
							type="select"
							options={templateOptions}
							isDisabled={isLoading || template.length === 0}
							checkIcon={true}
							placeholder={
								isLoading
									? "Loading templates..."
									: template.length === 0
										? "No template available"
										: "Select a template"
							}
							testId="select-rfq-template"
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default SelectTemplate;
